/* app/js/src/components/common/wizard/wizard.component.scss */
.cursor-pointer {
  cursor: pointer;
}
main section.step::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
main section.step::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
main section.step::-webkit-scrollbar-corner {
  background: transparent;
}
main section.step::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
main section.step::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
main section.step::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
main section.step::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
main section.step::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
main section.step::-webkit-scrollbar-thumb {
  border-width: 0;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
}
header div {
  font-size: 12px;
  font-weight: bold;
  color: #232f3a;
  letter-spacing: -0.1px;
  height: 54px;
  padding: 18px 27px 27px 27px;
}
main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1px;
}
main section {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  justify-content: space-around;
  display: flex;
}
main section.step {
  margin: 35px 0;
  overflow-y: auto;
}
main section.step .div-step {
  width: 88%;
  max-width: 450px;
  height: max-content;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
main section.summary {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 40%;
}
.step-title {
  font-size: 20px;
  letter-spacing: -0.1px;
  color: #232f3a;
  white-space: pre-wrap;
}
/*# sourceMappingURL=wizard.component.css.map */
